import { render, staticRenderFns } from "./WaitPay.vue?vue&type=template&id=ae7b8fe8&scoped=true&"
import script from "./WaitPay.vue?vue&type=script&lang=js&"
export * from "./WaitPay.vue?vue&type=script&lang=js&"
import style0 from "./WaitPay.vue?vue&type=style&index=0&id=ae7b8fe8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae7b8fe8",
  null
  
)

export default component.exports